import styled from '@emotion/styled';

import { ColumnsMixin } from './Columns.mixin';

export const Columns = styled.section`
  ${ColumnsMixin}
`;
